import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './BindingPage.module.scss';
import { Toast } from 'antd-mobile';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import statusReminderSvg from '../../assets/status-reminder.svg';
import { decodeBase64Object } from 'shared/common';
import useLineLiff from 'hooks/LineLiff';
import axios from 'axios';

export default function BindingWarn() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  const { liff } =
    useLineLiff(process.env.REACT_APP_LIFF_ID_LOGIN_CALLBACK);

  const handleUnbind = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login/hotai/unbind`, {
        token: liff.getIDToken(),
      });
      if (response.data.success) {
        Toast.show({
          content: response.data.message || '解除綁定完成',
          icon: 'success',
          duration: 2000,
        })
      }
      setTimeout(() => {
        navigate('/hotai/login');
      }, 2000);
    } catch (error) {
      console.error('Failed to unbind:', error);
      Toast.show({
      content: error.response.data.message || '解除綁定失敗',
      icon: 'fail',
      duration: 3000,
    });
    }
  };

  useEffect(() => {
    const queryParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );
    const decodedParams = decodeBase64Object(queryParams);
    setMessage(decodedParams.message);
  }, []);

  return (
    <div className="center-viewport">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
          <div className={styles['center-card']}>
            <img src={statusReminderSvg} alt="發生錯誤" className={styles['status-icon']} />
            <div className={styles['status-title']}>發生錯誤</div>
            <div className={styles['status-desc']}>{message}</div>
            <button className={styles['status-btn'] + ' ' + styles['status-btn-red']} onClick={handleUnbind}>解除綁定重新認證</button>
          </div>
    </div>
  );
} 